<script>
    import { getContext } from 'svelte';
    import { location } from 'svelte-spa-router'

    import { routedTabs } from './RoutedTabs.svelte';
    import { setSettingObject } from '../../utils'

    export let path;
    export let label = path;
    export let component = null;

    const { registerTab, persistKey, prefix } = getContext(routedTabs);
    const thisTab = { path, component, props: $$restProps }
    const fullPath = `${prefix}${path}`
    registerTab(thisTab);



</script>

<li class="nav-item">
	<a
		class="nav-link"
		class:active={$location === fullPath}
		on:click={() =>
			persistKey && setSettingObject(persistKey, { defaultPath: fullPath })}
		href="#{fullPath}"
	>
		{label}
	</a>
</li>
